export default class Point {
    public x: number;
    public y: number;

    constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
    }

    public equals(point: Point) {
        return this.x === point.x && this.y === point.y;
    }

    public clone(): Point {
        return new Point(this.x, this.y);
    }

    public toString(): string {
        return this.x.toString() + "," + this.y.toString();
    }

    public add(point: Point): Point {
        return new Point(this.x + point.x, this.y + point.y);
    }

    public divide(n: number): Point {
        return new Point(this.x / n, this.y / n);
    }

    public distanceTo(point: Point): number {
        return Math.sqrt(
            Math.pow(this.x - point.x, 2) +
            Math.pow(this.y - point.y, 2)
        );
    }

    public multiply(n: number): Point {
        return new Point(this.x * n, this.y * n);
    }

    public subtract(point: Point): Point {
        return new Point(this.x - point.x, this.y - point.y);
    }
}
